// extracted by mini-css-extract-plugin
export var content = "Showcase-module--content--c20da";
export var heading = "Showcase-module--heading--e149a";
export var indicator = "Showcase-module--indicator--19a38";
export var item = "Showcase-module--item--c0c74";
export var itemFull = "Showcase-module--itemFull--71549";
export var itemHalf = "Showcase-module--itemHalf--9c891";
export var itemQuarter1 = "Showcase-module--itemQuarter1--6381d";
export var itemQuarter2 = "Showcase-module--itemQuarter2--93d0b";
export var link = "Showcase-module--link--ec68e";
export var media = "Showcase-module--media--0ee30";
export var mediaWrapper = "Showcase-module--mediaWrapper--3a7ca";
export var navButton = "Showcase-module--navButton--e2a7f";
export var poster = "Showcase-module--poster--33201";
export var showcase = "Showcase-module--showcase--f0c2c";
export var slide = "Showcase-module--slide--caeda";
export var subtitle = "Showcase-module--subtitle--e5bc2";
export var swiper = "Showcase-module--swiper--55abf";
export var tabButton = "Showcase-module--tabButton--bf7ec";
export var tabContent = "Showcase-module--tabContent--046b7";
export var tabs = "Showcase-module--tabs--d5cae";
export var tabsContent = "Showcase-module--tabsContent--15f16";
export var tabsList = "Showcase-module--tabsList--4ace8";
export var text = "Showcase-module--text--a81f0";
export var title = "Showcase-module--title--34694";
export var video = "Showcase-module--video--98db2";